/*
 * Module to display a list of Appointment Types. Exports only APPTypeList 
 * component. 
 */
import React, {useState}                                    from 'react';

import ButtonHolder                     from    '../ButtonHolder';
import DataCapture                      from '../FormDesigner/Form/DataCapture';

// the base hosting URL of the site. CSS and images are relative
const PUBLIC_URL=process.env.PUBLIC_URL;

const ClientCapture = ({capturedData, doUpdate}) => {
    
    const [clientID, setClientID]                   = useState(0);
    const [showingWarning, setShowingWarning]     = useState(false);
    
    const { websiteConfig: { Clients: clients } }   = capturedData;
    
    const doAction = () => {
        //find the appointment data (description etc)
        const client = clients
            .filter( t => t.ClientPartyID === clientID )[0]
        
        const clientOb                 = new DataCapture()
        clientOb.Client                = client
        
        doUpdate( clientOb )
    }
    
    const buttonEnabled = (0 != clientID && !showingWarning);
    
    const handleChange = client => {  
        
        setClientID(client);
    }
    
    return (
        <>
            <h2 className="center">
                Select a customer or scheme name
            </h2>
            <ClientList setClient={handleChange} clientID={clientID} 
                clients={clients} setShowingWarning={setShowingWarning} />
            {showingWarning && <SelectWarning setClientID={setClientID} setShowingWarning={setShowingWarning} />}
            <ButtonHolder action={doAction}  actionTxt={'Select'}
                 enabled={buttonEnabled} />
        </>
    )
}

const SelectWarning = ({setClientID, setShowingWarning}) => (
    <div className="warning-overlay">
        <div className="warning-popup">
            <div className="warning-content">
                Before submitting the referral, please check you've selected the
                correct plan type.
            </div>
            <ButtonHolder action={()=>setShowingWarning(false)} enabled={true}
            actionTxt={"OK"} cancelTxt={"Cancel"} cancel={() => {setClientID(0); setShowingWarning(false);}} />
        </div>
    </div>
);

/**
 * Component to show a list of appointment types with icons and an checkbox 
 * input field to allow the user to select 
 * @returns {JSX}
 */
const ClientList = ({clientID, setClient, clients, setShowingWarning}) => {
    const handleClick = e => {
        const atInt = parseInt(e.target.value)
        setClient( atInt );
        clients.find( c => c.ClientPartyID === atInt )?.ShowWarning? setShowingWarning(true): setShowingWarning(false);
    }

    const types = clients.map( client => {
        
        const id = Number.parseInt(client.ClientPartyID);
        const selected = clientID === id;
        return (<ClientItem key={id} id={id} onSelect={handleClick}
            title={client.Name}  selected={selected} />) 
        }
    )
    
    return (
        <div className="appointment-types"  >
            {types}
        </div>
    )
}

/*
 * Component to represent a single type in the select list
 */
const ClientItem = ({id, title, selected, onSelect}) => {

    const img = selected? (<img className="appointment-types__type-checked" src={PUBLIC_URL + '/images/check.svg'} alt="checked"/>): ''
    
    const idSt = 'appointment-type-' + id
    
    //const IconSVG = getImageForAppTypeURL( icon );
    
    return (
        <>
            <input 
                    className="appointment-types__type-input" 
                    type="radio" 
                    name="appointment-type"
                    value={id}
                    id={idSt}
                    checked={selected}
                    onChange={onSelect} />
            <label className="appointment-types__type" htmlFor={idSt} >
                

                <span className="appointment-types__type-content">
                        <span className="h2 appointment-types__type-content-title">
                            {title}
                        </span>

                        
                    </span>

                <span className="appointment-types__type-checkbox" style={{opacity: selected? 1: 0}} >
                    {img}
                </span>
            </label> 
        </>
    )
};

export default ClientCapture;
